import {
  VehicleSelectionDispatchTypes,
  VEHICLE_SELECTION_LOADING,
  VEHICLE_SELECTION_SUCCESS,
} from "../actions/vehicleSelectionActionTypes";

interface VehicleSelectionState {
  loading: boolean;
  vehicleSelection?: string;
}

const defaultState: VehicleSelectionState = {
  loading: false,
};

const vehicleSelectionReducer = (
  state: VehicleSelectionState = defaultState,
  action: VehicleSelectionDispatchTypes
): VehicleSelectionState => {
  switch (action.type) {
    case VEHICLE_SELECTION_LOADING:
      return { ...state, loading: true };
    case VEHICLE_SELECTION_SUCCESS:
      return { loading: false, vehicleSelection: action.payload };
    default:
      return state;
  }
};

export default vehicleSelectionReducer;
